module.exports = __webpack_public_path__ + "static/media/win.92310432.png";